const _isObject = item => {
  return item && typeof item === 'object' && !Array.isArray(item);
};

export const mergeDeep = (target, source) => {
  let output = Object.assign({}, target);
  if (_isObject(target) && _isObject(source)) {
    Object.keys(source).forEach(key => {
      if (_isObject(source[key])) {
        if (!(key in target))
          Object.assign(output, {
            [key]:
              source[key] !== undefined
                ? source[key]
                : target[key] !== undefined
                  ? target[key]
                  : undefined,
          });
        else output[key] = mergeDeep(target[key], source[key]);
      } else {
        Object.assign(output, {
          [key]:
            source[key] !== undefined
              ? source[key]
              : target[key] !== undefined
                ? target[key]
                : undefined,
        });
      }
    });
  }
  return output;
};
